import LectureVersion from 'components/pages/lecture/lectureversion/LectureVersion';
import ContentCurriculum from '../contentcurriculum/ContentCurriculum';

import classes from './ContentObjectives.module.scss';

const ContentObjectives = ({
	title,
	lectureId,
	versioning,
	description,
	learning_objectives,
	content_type = 'course'
}) => {
	return (
		<div className={`${classes['content-objectives-wrapper']} d-flex flex-column gap-3`}>
			{learning_objectives && learning_objectives.length > 0 && (
				<>
					<h3>{content_type === 'course' ? 'Your Learning Objectives' : 'Courses'}</h3>
					<p>{description}</p>
					{learning_objectives && learning_objectives.length > 0 && (
						<ContentCurriculum data={learning_objectives} content_type={content_type} />
					)}
				</>
			)}
			{!!versioning && content_type === 'course' && (
				<div className="col-12 col-md-6 col-xl-12 order-1 order-md-2">
					<LectureVersion lecture_title={title} {...versioning} id={lectureId} />
				</div>
			)}
		</div>
	);
};

export default ContentObjectives;
